<template>
  <WsRow class="w-full">
    <slot name="front-custom-filters" />
    <WsCol
      v-for="(filterItem, filterKey) in filterFields"
      :key="filterKey"
      :cols="filterItem.cols ? filterItem.cols : 3"
      :smcols="filterItem.smcols ? filterItem.smcols : 6"
    >
      <AppFilter
        :value="$_getValue(value, filterItem.name)"
        :type="filterItem.type"
        :title="filterItem.title"
        :placeholder="filterItem.placeholder"
        :items="filterItem.items"
        :btn-icon="filterItem.btnIcon"
        :all-select-text="filterItem.allSelectText"
        :leading-icon="filterItem.leadingIcon"
        :font-size-lg="filterItem.fontSizeLg"
        :primary="filterItem.primary"
        :no-padding="filterItem.noPadding"
        :btn-text="filterItem.btnText"
        :default-value="filterItem.defaultValue"
        :download-btn-list="filterItem.downloadBtnList"
        :has-search="filterItem.hasSearch"
        :selectAll="filterItem.selectAll"
        :url="filterItem.url"
        :params="filterItem.params"
        :emptyText="filterItem.emptyText"
        :scroll="scroll"
        :leftBtnText="filterItem.leftBtnText"
        :disableCancel="filterItem.disableCancel"
        @input="$_onInput(filterItem.name, $event)"
        @button="$_onButton(filterItem.name)"
        @download-click="$_onDownload($event)"
      />
    </WsCol>
    <WsCol v-if="btns" cols="2" smcols="6">
      <slot name="btns" />
    </WsCol>
  </WsRow>
</template>
<script>
export default {
  name: 'AppFilterBar',
  props: {
    filterFields: {
      type: Array,
      default() {
        return [];
      },
    },
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    btns: {
      type: Boolean,
      default: false,
    },
    allSelectText: {
      type: String,
      default: '',
    },
    scroll: {
      type: Number,
    },
  },
  methods: {
    $_onChange($event) {
      this.$emit('input', $event);
    },
    $_getValue(value, name) {
      if (!value) {
        return null;
      } else {
        return value[name];
      }
    },
    $_onInput(name, $event) {
      const _value = {
        ...this.value,
        [name]: $event,
      };
      this.$emit('input', _value);
    },
    $_onButton(name) {
      this.$emit('button', name);
    },
    $_onDownload($event) {
      this.$emit('download-click', $event);
    },
  },
};
</script>
